"use strict";
import {toArray as value} from '../tutils';
const api = {value};
export default api;


/** WEBPACK FOOTER **
 ** ./~/subschema/src/processors/ArrayProcessor.js
 **/